import React, { FunctionComponent } from "react";
import { IStickyNavItem } from "../../../Models/IStickyNavItem";
import {
    StickyNav,
    StickyNavContent,
    StickyNavItem,
} from "../ReportStyles/ReportStickyNav";

interface IReportStickyNavProps {
  id: string;
  containerId: string;
  stuckClass: string;
  stickyNavItems: IStickyNavItem[];
}

const ReportStickyNav: FunctionComponent<IReportStickyNavProps> = ({
    id,
    containerId,
    stuckClass,
    stickyNavItems,
}: IReportStickyNavProps) => {
    return (
        <>
            <StickyNav id={id} className={stuckClass}>
                <StickyNavContent>
                    {stickyNavItems.map((item: IStickyNavItem, i) => {
                        return (
                            <StickyNavItem
                                key={i}
                                activeClass={`active`}
                                to={item.toComponent}
                                spy={true}
                                smooth={true}
                                offset={item.offset}
                                duration={800}
                                containerId={containerId}
                                color={item.color}
                            >
                                {item.title}
                            </StickyNavItem>
                        );
                    })}
                </StickyNavContent>
            </StickyNav>
        </>
    );
};

export default ReportStickyNav;
